import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link
} from "react-router-dom";
import { toast } from 'react-toastify';
import { observable } from 'mobx';
import { sessionService } from '../../services/SessionService';

interface ViewMobilePaymentProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}

@observer export default class ViewMobilePayment extends React.Component<ViewMobilePaymentProps> {

    @observable private mobilePayment: any;
    @observable private isLoaded = false;

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        const match = this.props.match;
        const id = (match as any).params.id;
        http.get(`/api/mobile_payments/read/${id}`).then((response) => {
            this.mobilePayment = response.data;
            this.isLoaded = true;
        })
            .catch((error) => {
                toast.error("Error cargando método de pago móvil");
            });
    }

    render() {
        if (!this.isLoaded) {
            return null;
        }
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header card-header-rose card-header-text">
                                <div className="card-text">
                                    <h4 className="card-title">Método de Pago Móvil: {this.mobilePayment?.name}</h4>
                                </div>
                            </div>
                            <div className="card-body ">
                                <div className="row">
                                    <div className="col-sm-8"></div>
                                    <div className="col-sm-2">
                                        {sessionService.canViewSection("Pagos Móvil.edit") &&
                                            <Link to={`../${this.mobilePayment?.id}`}>
                                                <button className="btn btn-success btn-sm  pull-right">
                                                    <i className="material-icons">edit</i>
                                                    <div className="ripple-container"></div>
                                                </button>
                                            </Link>
                                        }
                                    </div>
                                    <div className="col-sm-2">
                                        <Link to={`../../pagos-movil`}>
                                            <button className="btn btn-danger btn-sm  pull-right">
                                                <i className="material-icons">highlight_off</i>
                                                <div className="ripple-container"></div>
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Nombre del Método de Pago</label>
                                    <div className="col-sm-8">
                                        <strong>{this.mobilePayment?.name}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Descripción</label>
                                    <div className="col-sm-8">
                                        <strong>{this.mobilePayment?.description || 'Sin descripción'}</strong>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-4">Estado</label>
                                    <div className="col-sm-8">
                                        <strong>
                                            {this.mobilePayment?.disabled === 0 || this.mobilePayment?.disabled === null ? 'Habilitado' : 'Deshabilitado'}
                                        </strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

